<template>
  <div>
    <section v-if="!disabled" class="btn-group">
      <el-button type="primary" @click="handleAdd">新增下架歌曲信息</el-button>
      <el-button @click="handleShowBatchUpload">批量录入下架歌曲</el-button>
    </section>
    <el-table :data="data">
      <el-table-column label="歌单ID" prop="tracklistId"></el-table-column>
      <el-table-column label="下架歌曲信息" align="center">
        <el-table-column label="媒体类型" v-slot="{ row }">{{ mediaTypeMap[row.meidaType] }}</el-table-column>
        <el-table-column label="TMEID" prop="appealTrackId"></el-table-column>
        <el-table-column label="作品名称" prop="trackName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="歌手名" prop="singerName"></el-table-column>
        <el-table-column label="专辑名" prop="albumName"></el-table-column>
        <el-table-column label="版本" prop="srcVersion"></el-table-column>
        <el-table-column label="词作者" prop="originWordAuthor"></el-table-column>
        <el-table-column label="曲作者" prop="originMusicAuthor"></el-table-column>
        <el-table-column label="平台" v-slot="{ row }">{{ appealPlatMap[row.appealPlat] }}</el-table-column>
        <el-table-column label="作品链接" v-slot="{ row }" show-overflow-tooltip>
          <a v-if="row.appealUrl" :href="row.appealUrl" target="_blank">{{ row.appealUrl }}</a>
          <template v-else>-</template>
        </el-table-column>
        <el-table-column label="歌曲编码" prop="trackNumber"></el-table-column>
        <el-table-column label="ISRC" prop="isrc"></el-table-column>
        <el-table-column label="专辑编码" prop="discNumber"></el-table-column>
        <el-table-column label="UPC" prop="upc"></el-table-column>
        <el-table-column label="专辑发行时间" prop="saleTime" width="120"></el-table-column>
        <el-table-column label="作品别名" prop="originTrackName" width="120"></el-table-column>
        <el-table-column label="歌手别名" prop="originSingerName"></el-table-column>
        <el-table-column label="曲序" prop="location"></el-table-column>
        <el-table-column label="专辑别名" prop="originAlbumName"></el-table-column>
        <el-table-column label="权利文件" v-slot="{ row }" show-overflow-tooltip>
          <a v-if="row.rightFile" :href="row.rightFile.fileUrl" :download="row.rightFile.fileName">
            {{ row.rightFile.fileName }}
          </a>
          <template v-else>-</template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        v-if="!disabled"
        label="操作"
        width="120"
        align="center"
        fixed="right"
        v-slot="{ row }"
      >
        <el-button type="text" @click="handleShowEdit(row)">编辑</el-button>
        <span class="divide" />
        <el-button type="text" style="color:red;" @click="handleDel(row)">删除</el-button>
      </el-table-column>
    </el-table>

    <batch-upload-dialog
      dialog-title="批量录入下架歌曲"
      :visible.sync="showBatchUpload"
      :buss-type="LEVEL_ONE_APPEAL.OFFLINE.code"
      @submit="handleUpload"
    ></batch-upload-dialog>

    <el-dialog
      v-if="showEdit"
      :title="dialogTitle"
      :visible.sync="showEdit"
      width="1060px"
      custom-class="complaint-search-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
    >
      <el-form
        ref="form"
        label-width="130px"
        inline
        :model="form"
        :rules="rules"
      >
        <section class="search-sec">
          <section class="sec-wrapper">
            <div class="sec-title">
              <svg-icon icon-class="offline-track" class="icon"></svg-icon>
              <span>下架歌曲信息</span>
              <auto-parser class="auto-url-parser" @submit="handleAutoParse"></auto-parser>
            </div>
            <div class="sub-mod">
              <custom-collapse ref="collapseRef" class="form-collapse" :collapse-text="collapseText">
                <el-form-item label="媒体类型" required>
                  <el-select
                    v-model="form.meidaType"
                    style="width:100%"
                  >
                    <el-option
                      v-for="(item, key) in mediaTypeMap"
                      :key="key"
                      :value="+key"
                      :label="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="作品名称" prop="trackName">
                  <el-input
                    placeholder="请输入"
                    v-model="form.trackName"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="歌手名" prop="singerName">
                  <el-input
                    placeholder="请输入"
                    v-model="form.singerName"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="平台" prop="appealPlat">
                  <el-select
                    v-model="form.appealPlat"
                    style="width:100%"
                  >
                    <el-option
                      v-for="(item, key) in appealPlatMap"
                      :key="key"
                      :value="+key"
                      :label="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="作品链接" prop="appealUrl">
                  <el-input
                    style="width: 512px"
                    placeholder="请输入"
                    v-model="form.appealUrl"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item class="full" prop="rightFileList">
                  <template #label>
                    <span>权利文件</span>
                    <el-tooltip placement="top">
                      <i class="el-icon-info" />
                      <template #content>
                        具体文件要求，请查看：<a href="https://doc.weixin.qq.com/doc/w3_AMAAvgZ6ACooVs4k4OATpC9MB3lbi?scode=AJEAIQdfAAouI78nuGAGQA6AbQACk">权利文件上传要求</a>
                      </template>
                    </el-tooltip>
                  </template>
                  <verify-uploader
                    class="custom-uploader"
                    action="/action/upload?type=license"
                    drag
                    multiple
                    :on-remove="handleRightFileRemove"
                    :on-error="handleRightFileError"
                    :on-success="handleRightFileSuccess"
                    :before-upload="handleRightFileBeforeUpload"
                    :file-list="form.rightFileList"
                    :accept="'.' + rightFileExtType.join(',.')"
                  >
                    <div slot="trigger" class="upload-trigger">
                      <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
                      <p>点击或将文件拖拽上传权利文件</p>
                      <span>支持格式：{{ rightFileExtType.join(',') }}</span>
                    </div>
                  </verify-uploader>
                </el-form-item>
                <template #hide>
                  <el-form-item label="专辑名">
                    <el-input
                      placeholder="请输入"
                      v-model="form.albumName"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="版本">
                    <el-input
                      placeholder="请输入"
                      v-model="form.srcVersion"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="TMEID">
                    <el-input-number
                      placeholder="请输入"
                      v-model="form.appealTrackId"
                      :controls="false"
                      clearable
                      style="width:185px"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item label="词作者">
                    <el-input
                      placeholder="请输入"
                      v-model="form.originWordAuthor"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="曲作者">
                    <el-input
                      placeholder="请输入"
                      v-model="form.originMusicAuthor"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="歌曲编码">
                    <el-input
                      placeholder="请输入"
                      v-model="form.trackNumber"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="ISRC">
                    <el-input
                      placeholder="请输入"
                      v-model="form.isrc"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="专辑编码">
                    <el-input
                      placeholder="请输入"
                      v-model="form.discNumber"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="UPC">
                    <el-input
                      placeholder="请输入"
                      v-model="form.upc"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="曲序">
                    <el-input-number
                      placeholder="请输入"
                      v-model="form.location"
                      :controls="false"
                      clearable
                      style="width:185px"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item label="专辑发行时间">
                    <el-date-picker
                      v-model="form.saleTime"
                      type="datetime"
                      placeholder="专辑发行时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width:185px"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="作品别名">
                    <el-input
                      placeholder="请输入"
                      v-model="form.originTrackName"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="歌手别名">
                    <el-input
                      placeholder="请输入"
                      v-model="form.originSingerName"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="专辑别名">
                    <el-input
                      placeholder="请输入"
                      v-model="form.originAlbumName"
                      clearable
                    ></el-input>
                  </el-form-item>
                </template>
              </custom-collapse>
            </div>
          </section>
        </section>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  LEVEL_ONE_APPEAL,
} from '../const'
import basicAddTable from './basicAddTable'

export default {
  name: 'OfflineAddTable',
  mixins: [basicAddTable],
  computed: {
    /**
     * @returns{String}
     */
    dialogTitle() {
      return this.form && +this.form.tracklistId ? `编辑歌单（${this.form.tracklistId}）` : '新增下架歌曲信息'
    },
  },
  methods: {
    handleUpload(fileList, rightFileList) {
      const params = {
        url: fileList[0].url,
        complaintType: LEVEL_ONE_APPEAL.OFFLINE.code,
        rightFileList
      }
      this.$emit('upload', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-group {
  margin-bottom: 16px;
}

.icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.upload-trigger {
  margin-top: 16px;

  .upload-icon {
    width: 42px;
    height: 50px;
  }

  p {
    margin: 10px 0;
  }
}

::v-deep .complaint-search-dialog {
  .custom-uploader {
    .el-upload.el-upload--text {
      width: 50%;
      background: #F3F3F3;
      border: 1px dashed #4071FF;
      border-radius: 4px;
      padding: 10px;
    }

    .el-upload-dragger {
      background-color: unset;
      border: none;
      width: 100%;
      min-height: 180px;
      height: 100%;
    }
  }

  .el-form {
    .el-form-item__content {
      width: 185px;
    }

    .full.el-form-item {
      display: flex;
      margin-bottom: 0;
      padding-bottom: 18px;
      .el-form-item__content {
        flex: 1;
      }
    }
  }

  .search-sec {

    .sec-wrapper {
      padding: 12px 16px;
      background: #F9F9F9;
      border: 1px solid rgba(0, 0, 0, 0.14);

      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }

    .sec-title {
      padding-top: 8px;
      margin-bottom: 16px;
      color: #002444;

      > span {
        font-weight: bold;
      }

      .auto-url-parser {
        float: right;
      }
    }
  }
}

.dialog-footer {
  text-align: center;
}

.form-collapse {
  ::v-deep {
    .tip {
      float: left;
      width: 130px;
      text-align: right;
      font-size: 12px;
      color: #4071ff;
    }
  }
}
</style>
